import EventEmitter from 'event-emitter';
import Raven from 'raven-js';

export default class ProgressUpload {

  constructor(options) {

    if (!(this instanceof ProgressUpload)) {
      return new ProgressUpload(options);
    }

    const startTime = Date.now();

    // Set up the initial state
    this.uploadPercentComplete = 0;
    this.downloadPercentComplete = 0;

    // Make the HTTP Request
    this.xhr = new XMLHttpRequest();
    this.xhr.addEventListener('progress', (ev) => {

      if (ev.lengthComputable) {
        this.downloadPercentComplete = ev.loaded / ev.total;
      }

      this.emit('progress', this);
    });
    this.xhr.upload.addEventListener('progress', (ev) => {

      if (ev.lengthComputable) {
        this.uploadPercentComplete = ev.loaded / ev.total;
      }

      this.emit('progress', this);
    });
    this.xhr.addEventListener('load', () => {

      // JSON parse here to avoid IE11 bug with responseType
      if (typeof this.xhr.response === 'string') {
        try {
          this.response = JSON.parse(this.xhr.response);
        } catch (e) {
          const duration = Date.now() - startTime;
          Raven.captureException(e, {
            extra: {
              duration,
              xhrResponse: this.xhr.response
            }
          });

          return this.emit('error', this);
        }
      } else {
        this.response = this.xhr.response;
      }

      this.emit('load', this);
    });
    this.xhr.addEventListener('error', () => this.emit('error', this));
    this.xhr.addEventListener('abort', () => this.emit('abort', this));
    this.xhr.open('POST', options.url);
    this.xhr.send(options.body);
  }

  get percentComplete() {
    return (this.uploadPercentComplete * 0.95) + (this.downloadPercentComplete * 0.05);
  }

  abort() {
    this.xhr.abort();
  }
}

// Initialize the event emitter on all classes
EventEmitter(ProgressUpload.prototype);



// WEBPACK FOOTER //
// ./src/modules/ImageresizeApi/ProgressUpload.js